var map = {
	"./appcharts.vue": 81879,
	"./builderimages.vue": 64807,
	"./catalogservices.vue": 94290,
	"./configurations.vue": 80848,
	"./gitconfigs.vue": 35877,
	"./namespaces.vue": 26926,
	"./services.vue": 13047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9410;